import type { PhantomType } from '@moojo/phantom-type'
import { z } from 'zod'

export type SensitiveString = PhantomType<string, 'SensitiveString'>
export const SensitiveString = {
  make,
  zod: z.string().transform(x => make(x)),
}

function make(arg: string) {
  return arg as SensitiveString
}
